// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, xScreen } from "@conklin/XDL/Utilities";
import { productLinesStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsProductLines";
import { css } from "styled-components";

productLinesStyles.title = {
    variant: "h2",
    css: css`
        margin-bottom: 32px;
    `,
};
productLinesStyles.container = {
    css: css`
        margin: 30px 0;
    `,
};

productLinesStyles.productLineContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        ${({ gridType }: any) => {
            if (gridType !== "row") {
                return css`
                    flex-direction: column;
                `;
            }
        }}
    `,
};

productLinesStyles.innerProductLineContainer = {
    css: css`
        &:hover {
            .productLine-name {
                color: ${color("common.ui10")};
            }
        }
        max-width: 200px;
        ${xScreen("lte", "md")} {
            max-width: 165px;
        }
        ${xScreen("lte", "sm")} {
            max-width: 150px;
        }
    `,
};

productLinesStyles.productLineImage = {
    css: css`
        object-fit: cover;
        width: 200px;
        height: 200px;
        img {
            width: 100%;
        }
        ${xScreen("lte", "md")} {
            width: 165px;
            height: 165px;
        }
        ${xScreen("lte", "sm")} {
            width: 150px;
            height: 150px;
        }
    `,
};

productLinesStyles.productLineNameLink = {
    typographyProps: {
        size: 15,
        weight: fontConfig.weight.bold,
    },
    css: css`
        letter-spacing: 0;
        line-height: 17px;
        display: block;
        text-align: center;
        margin-top: 10px;
        &&& span {
            color: ${color("text.main")};
        }
    `,
};

productLinesStyles.productLineName = {
    size: 15,
    weight: fontConfig.weight.bold,
    css: css`
        letter-spacing: 0;
        line-height: 17px;
        display: block;
        text-align: center;
        margin-top: 10px;
        color: ${color("text.main")};
    `,
};
